const roles = [];

const reducer = (state = roles, action) => {
  switch (action.type) {
    case 'set_user_role':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
